import productLensJson from '../../demo/fixtures/w2/product-lens.json'
import type { AnalyticsLens } from '../../demo/types'
import type { AnalyticsTableView } from './ViewSwitch'

interface ProductLensFixture {
  acosRedline: number
  columns: Record<AnalyticsLens, string[]>
}

const fixture = productLensJson as unknown as ProductLensFixture

export const lensColumns = fixture.columns
export const acosRedline = fixture.acosRedline
export const lensColumnTermKeys: Record<string, string> = { 千次展示成本: 'cpm' }

export const lensCopy = {
  title: '商品表现',
  subtitle: '点开商品，看它靠哪条素材在卖',
  viewAriaLabel: '表格视角',
  views: {
    campaign: '广告视角',
    product: '商品视角',
  } satisfies Record<AnalyticsTableView, string>,
  expandProduct: '展开商品广告',
  linkOk: '商品链接正常',
  linkInvalid: '商品链接失效',
  linkInvalidShort: '链接失效',
  total: '合计',
  adCount: (ads: number, adsLive: number) => `${ads} 条 · ${adsLive} 条在投`,
  totalAds: (ads: number) => `${ads} 条`,
  creativeVideo: (duration: string | null) => `视频 ${duration ?? ''}`.trim(),
  creativeImage: '图片',
  status: {
    rejected: '已拒登',
    throttled: '已限流',
    risk: '有风险',
    live: '投放中',
  },
  metrics: {
    spend: '花费',
    impressions: '展示',
    orders: '转化订单',
    reach: '触达人数',
  },
  openAd: (name: string) => `查看 ${name}`,
} as const
